import Button from 'components/shared/Button/Button';

const ExportButton = ({ open, customLabel, ...props }) => {
  const color = open ? 'primary' : 'neutral';
  return (
    <Button
      size="xs"
      color={color}
      variant="tertiary"
      text={customLabel}
      icon="export-mono"
      iconColor="neutral"
      textClassName={`text-${color}-700`}
      style="outlined"
      {...props}
    />
  );
};

export default ExportButton;
